import { deepMerge } from '@empathybroker/deep-merge';
import { ConfigState, EmpathyXConfig, ResultComponentsConfig, ResultConfig, ResultsConfig } from '../../../models';
import { DeepPartial } from '../../../utils';
import { CONFIG_GETTERS_KEYS } from '../../config/config.const';
import { ConfigGetter } from '../config.interfaces';

export class ResultsGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.gridResultConfig]: this.getResultsConfigGetter('resultsGrid'),
    [CONFIG_GETTERS_KEYS.identifierSuggestionsResultConfig]: this.getResultsConfigGetter('identifierSuggestions'),
    [CONFIG_GETTERS_KEYS.nextQueryResultConfig]: this.getResultsConfigGetter('nextQueries'),
    [CONFIG_GETTERS_KEYS.partialsResultConfig]: this.getResultsConfigGetter('partials'),
    [CONFIG_GETTERS_KEYS.recommendationsResultConfig]: this.getResultsConfigGetter('recommendations'),
    [CONFIG_GETTERS_KEYS.resultsSuggestionsResultConfig]: this.getResultsConfigGetter('resultsSuggestions'),
    [CONFIG_GETTERS_KEYS.fallbackFiltersResultConfig]: this.getResultsConfigGetter('fallbackFilters'),
    [CONFIG_GETTERS_KEYS.discoveryWallResultsConfig]: this.getResultsConfigGetter('discoveryWall')
  };

  protected getResultsConfigGetter(resultSection: keyof ResultsConfig): (state: ConfigState, getters: any) => ResultConfig {
    return (state: ConfigState, getters: any): ResultConfig => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      return this.mergeDefaultConfigs(config.results[resultSection], config.results.all);
    };
  }

  protected mergeDefaultConfigs(resultConfig: DeepPartial<ResultConfig>, defaultResultConfig: DeepPartial<ResultConfig>): ResultConfig {
    const mergedResultConfig: ResultConfig = deepMerge({}, defaultResultConfig, resultConfig);
    return Object.entries<ResultComponentsConfig>(mergedResultConfig).reduce((resultConfigWithDefaults, [type, resultTypeConfig]) => {
      if (mergedResultConfig.default !== resultTypeConfig) {
        resultConfigWithDefaults[type] = deepMerge({}, mergedResultConfig.default, resultTypeConfig);
      }
      return resultConfigWithDefaults;
    }, mergedResultConfig);
  }
}
